import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../store/store";
import Spinner from "../../components/Reuseables/Spinner/Spinner";

export default function ProtectedRoute({ children }) {
  const loading = useAuthStore((state) => state.loading);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (loading) return <Spinner />;
  return isAuthenticated ? children : <Navigate to="/admin/login" />;
}